import React from 'react';

import { getStaticsBaseUrl } from '@oysterjs/core/config';

/**
 * PDF iframe preview URL and loading state for the HTML document editor toolbar.
 */
export function useEditorPreview(params: {
  showPreview?: boolean;
  workspaceId?: string;
  artifactId?: string;
  artifactVersion?: number;
  /** Changes when Cara repairs the same artifact version. */
  artifactRevision?: string | number;
  templateId?: string;
}) {
  const { showPreview, workspaceId, artifactId, artifactVersion, artifactRevision, templateId } =
    params;

  const [isIframeLoading, setIsIframeLoading] = React.useState(false);

  React.useEffect(() => {
    if (showPreview) {
      setIsIframeLoading(true);
    }
  }, [showPreview, templateId, artifactVersion]);

  const previewUrl = React.useMemo(() => {
    const baseUrl = getStaticsBaseUrl();
    const params = new URLSearchParams();
    if (artifactRevision !== undefined) params.set('render_revision', String(artifactRevision));

    if (workspaceId && artifactId) {
      if (templateId) {
        params.set('style_id', templateId);
      }
      if (artifactVersion !== undefined) {
        params.set('version', String(artifactVersion));
      }
      const queryString = params.toString() ? `?${params.toString()}` : '';
      return `${baseUrl}/agency/html/${workspaceId}/${artifactId}/v2${queryString}`;
    }

    const queryString = params.toString() ? `?${params.toString()}` : '';
    if (templateId) {
      return `${baseUrl}/agency/preview-html/${templateId}${queryString}`;
    }

    return null;
  }, [artifactId, artifactVersion, artifactRevision, templateId, workspaceId]);

  const handleIframeLoad = React.useCallback(() => {
    setIsIframeLoading(false);
  }, []);

  return {
    isIframeLoading,
    previewUrl,
    handleIframeLoad
  };
}
